import React, { useState } from 'react';

export default function PasswordInput({ className = '', ...props }) {
  const [visible, setVisible] = useState(false);
  const label = visible ? 'Hide password' : 'Show password';

  return <div className={`password-input-wrap${className ? ` ${className}` : ''}`}>
    <input {...props} type={visible ? 'text' : 'password'} />
    <button type="button" className="password-visibility-btn" onClick={() => setVisible(value => !value)} aria-label={label} title={label} aria-pressed={visible}>
      {visible ? 'Hide' : 'Show'}
    </button>
  </div>;
}
